export const SkillsData = [
  {
    type: "Web-Development",
    list: [

      {
        name: "WordPress",
        icon: <i className="devicon-wordpress-plain colored"></i>
      },
      {
        name: "Shopify",
        icon: <i className="devicon-shopify-plain colored"></i>
      },
      {
        name: "ReactJS",
        icon: <i className="devicon-react-original colored"></i>
      },
      {
        name: "HTML5",
        icon: <i className="devicon-html5-plain colored"></i>
      },
      {
        name: "CSS3",
        icon: <i className="devicon-css3-plain colored"></i>
      },
      {
        name: "JavaScript",
        icon: <i className="devicon-javascript-plain colored"></i>
      },
      {
        name: "Tailwind",
        icon: <i className="devicon-tailwindcss-plain colored"></i>
      },
      {
        name: "MongoDB",
        icon: <i className="devicon-mongodb-plain colored"></i>
      },
      {
        name: "Express.js",
        icon: <i className="devicon-express-original colored"></i>
      },
      {
        name: "Node.js",
        icon: <i className="devicon-nodejs-plain colored"></i>
      },
      
      {
        name: "PHP",
        icon: <i className="devicon-php-plain colored"></i>
      },
      {
        name: "React Native",
        icon: <i className="devicon-react-original colored"></i>
      },
      {
        name: "Next.js",
        icon: <i className="devicon-nextjs-plain colored"></i>
      },
      {
        name: "Gatsby",
        icon: <i className="devicon-gatsby-plain colored"></i>
      }
      // Add any other relevant icons as needed
    ],
  },
];
